import {hashCustomerEmail} from '@amblique/king-living/app/utils/gtm-utils';

export const getCustomerParams = (customer) => {
  if (!customer?.isRegistered) {
    return {};
  }

  const customerid = customer.customerNo || customer.customerId;

  return customerid ? {customerid} : {};
};

export const getCustomerParamsWithEmail = async (customer) => {
  const params = getCustomerParams(customer);

  if (!customer?.email) {
    return params;
  }

  const customeremail = await hashCustomerEmail(customer.email);

  return customeremail ? {...params, customeremail} : params;
};

export const getSignUpCustomerParamsWithEmail = async (customer) => {
  const params = {};
  const customerid = customer?.customerNo || customer?.customerId;

  if (customerid) {
    params.customerid = customerid;
  }

  if (!customer?.email) {
    return params;
  }

  const customeremail = await hashCustomerEmail(customer.email);

  return customeremail ? {...params, customeremail} : params;
};
